export class FormMode
{
	static REGULAR: string = 'REGULAR';
	static READ_ONLY: string = 'READ_ONLY';
	static COMPILATION: string = 'COMPILATION';
	static COMPILATION_READ_ONLY: string = 'COMPILATION_READ_ONLY';
}